import React from "react";
import PaymentsV2Page from "./PaymentsV2Page";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface PaymentsV2PageContainerProps extends RouteProps, withValidUserRoleProps {}

const BillingPageV2Container = (props: PaymentsV2PageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <PaymentsV2Page title={getTitle()} category={getType()} />;
};

export default withValidUserRole(BillingPageV2Container);
